import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-verification-invalid',
  templateUrl: './verification-invalid.component.html',
  styleUrls: ['./verification-invalid.component.css']
})
export class VerificationInvalidComponent implements OnInit {

  constructor(private router: Router) { }

  startOver() {
    this.router.navigate(['/selfEnroll/getStarted']);
  }

  ngOnInit() {
  }

}
